var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0412 0.000343997C17.8538 0.00598326 17.6758 0.0842894 17.545 0.218824L6.5061 11.2577L1.24177 5.99338H1.24193C1.10756 5.85385 0.922589 5.77409 0.728779 5.77232C0.534952 5.77039 0.348533 5.8466 0.21142 5.98371C0.0744684 6.12066 -0.00174333 6.30708 3.02782e-05 6.5009C0.00196372 6.69473 0.0815586 6.8797 0.221249 7.01406L5.9958 12.7886C6.13114 12.9239 6.31482 13 6.50623 13C6.69764 13 6.88116 12.9239 7.0165 12.7886L18.5656 1.2395C18.7055 1.10351 18.7844 0.916778 18.7844 0.721648C18.7842 0.52653 18.7053 0.339793 18.5653 0.203959C18.4253 0.0679723 18.2363 -0.00533567 18.0412 0.000302773L18.0412 0.000343997Z",
    fill: "url(#paint0_linear_3_637)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_637",
    x1: 0,
    y1: 6.5,
    x2: 18.7844,
    y2: 6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA40F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E80DC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanIcon);
export default __webpack_public_path__ + "static/media/plan_icon.2f0bee01b763f080e4ea5e3fbd107176.svg";
export { ForwardRef as ReactComponent };